import { MtoNetwork } from '../../normalization/graphql/normalizeMultiTenantOrganizationDetails.types';
import { EntityStatus, YammerState, getStatus } from '../../state/types';

type GetMultiTenantOrganizationDetailsStatus = (state: YammerState) => EntityStatus;
export const getMultiTenantOrganizationDetailsStatus: GetMultiTenantOrganizationDetailsStatus = (state) =>
  getStatus(state.multiTenantOrganizationDetails);

type GetCurrentMtoNetwork = (state: YammerState) => MtoNetwork | null | undefined;
export const getCurrentMtoNetwork: GetCurrentMtoNetwork = (state) =>
  state.multiTenantOrganizationDetails?.fulfilled?.multiTenantHubNetwork;

type GetIsMtoAvailable = (state: YammerState) => boolean;
export const getIsMtoAvailable: GetIsMtoAvailable = (state) =>
  state.multiTenantOrganizationDetails?.fulfilled !== undefined;
